import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const CheckboxChecked = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="CheckboxChecked" {...rest}>
      <path fill="currentColor" d="M1 1h22v22H1z" />
      <path d="M19 7L8.613 17 5 13.522" stroke="#fff" strokeWidth="2" />
    </SvgIcon>
  );
};
